import React from 'react';
import { get } from 'lodash';
import { decodeUnicode } from '../general';
import LoadProducts from '../../components/organisms/LoadProducts/LoadProducts';
/**
 * Wordpress API Helper
 * 
 * Handles the formatting of the URL and actioning the fetch function
 * 
 * @param   {String} endpoint       The BC API endoint you need to call.
 * @param   {String} method         (Optional) The method for the call. Valid options are GET, POST, PUT, DELETE. Defaults to GET.
 * @param   {String|Object} body    (Optional) The body of the call if required. Will access either a stringified object or an object. If an object passed, it will be stringified before entry.
 * @param   {Number} version        (Optional) Version of the API to hit. 2 is assumed
 * 
 * @return  {Object}                {response, status}
 *
    import { wpApi } from '../helpers/wordpress'

    wpApi('endpoint', 'POST', bodyObject, version).then(({response, status}) => {
        console.log(response, status);
    }).catch(error => console.error(error));
 */
async function wpApi(endpoint, method, body, version) {
  const options = {
    method: method ? method : 'GET',
    credentials: 'same-origin',
    mode: 'same-origin'
  };

  if (body) {
    let bodyString = body;
    if (typeof body === 'object') {
      bodyString = JSON.stringify(body);
    }

    options.body = bodyString;
  }

  const parseJson = async response => {
    const text = await response.text();
    try {
      const json = JSON.parse(text);
      return json;
    } catch (err) {
      return text;
    }
  };

  return await fetch(
    `/.netlify/functions/wordpress?${
      version ? `v=${version}&` : ''
    }endpoint=${btoa(endpoint)}`,
    options
  ).then(async res => ({ response: await parseJson(res), status: res.status  , pagination : {
    total: res.headers.get('X-WP-Total'),
    totalPages: res.headers.get('X-WP-TotalPages'),
  }}));
}

function transformWpPost(post) {
  const wpComments = get(post, 'comments.nodes', []).flatMap(node => {
    const author = node.author.node;
    return { ...node, author };
  });

  let contentObj = [];

  if ('content' in post) {
    // console.log("Converted", decodeUnicode(post.content));
    const convertedContent = decodeUnicode(post.content);
    const productsRegex = /<p>\[products type="(.*)" skus="(.*)"\]<\/p>/gm;
    const shortcodes = [...convertedContent.matchAll(productsRegex)];
    // console.log(shortcodes);
    contentObj = [convertedContent];

    if (shortcodes.length > 0) {
      shortcodes.map(shortcode => {
        const contentNodes = [...contentObj];
        contentObj = [];
        contentNodes.map(contentNode => {
          if (typeof contentNode === 'string') {
            // console.log(typeof contentNode);
            const split = contentNode.split(shortcode[0]);
            const result = [];
            split.map(s => {
              result.push(s);
              result.push(
                <LoadProducts
                  columns="4"
                  displayType={shortcode[1]}
                  definitionType="Individual SKUs"
                  definitions={shortcode[2].split(',')}
                />
              );

              return true;
            });
            result.pop();
            contentObj = [...contentObj, ...result];
          } else {
            contentObj = [...contentObj, contentNode];
          }

          return true;
        });

        return true;
      });
    }
  }

  return {
    id: post.id,
    databaseId: post.databaseId,
    comments: wpComments,
    title: post.title,
    excerpt: post.excerpt,
    slug: `/blog${post.uri}`,
    content: post.content,
    contentArr: contentObj,
    author_name: post.author ? post.author.node.name : '',
    author_uri: post.author ? post.author.node.uri : '',
    published_date: post.date,
    tags: post.tags ? post.tags.nodes : [],
    categories: (post.categories.nodes || []).map(cat => ({
      ...cat,
      uri: `/blog${cat.uri}`
    })),
    seo: post?.seo ?? null,
    thumbnail_path: get(post, ['featuredImage', 'node', 'sourceUrl'])
  };
}

function extractPostSummary(blog) {
  if (blog !== undefined) {
    const blogDetails = blog.node;
    return {
      excerpt: blogDetails.excerpt,
      title: blogDetails.title,
      link: `${blogDetails.link}`,
      image: blogDetails.featuredImage.node.sourceUrl
    };
  } else {
    return {};
  }
}

export { wpApi, transformWpPost, extractPostSummary };
